import { Component } from '@angular/core';

@Component({
  selector: 'app-faq-video',
  templateUrl: './faq-video.component.html',
  styleUrls: ['./faq-video.component.css']
})
export class FaqVideoComponent {

}
